/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useContext, useEffect, useState } from "react";

export const HeaderPortalContext = createContext({
  portalContent: null,
  setPortalContent: () => {},
});

export const HeaderPortalProvider = ({ children }) => {
  const [portalContent, setPortalContent] = useState(null);
  return (
    <HeaderPortalContext.Provider
      value={{
        portalContent,
        setPortalContent,
      }}
    >
      {children}
    </HeaderPortalContext.Provider>
  );
};

const useHeaderPortal = (renderContent, deps = []) => {
  const { setPortalContent } = useContext(HeaderPortalContext);

  useEffect(() => {
    setPortalContent(renderContent());
    return () => {
      setPortalContent(null);
    };
  }, [setPortalContent, ...deps]);
};

export default useHeaderPortal;
